import { Typography } from '@mui/material';
import { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { AlertModal, ModalTopUp } from 'shared';
import { userDataSelector } from 'store/slices/user-slice';

export enum BalanceModalType {
  NONE = 'NONE',
  NEGATIVE_BALANCE = 'NEGATIVE_BALANCE',
  LOW_BALANCE = 'LOW_BALANCE',
}

export const TopUpBalanceModal = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isTopupOpened, setIsTopupOpened] = useState(false);
  const [modalType, setModalType] = useState<BalanceModalType>(BalanceModalType.NONE);

  const user = useSelector(userDataSelector);

  useEffect(() => {
    if (!user) return;
    const balance = user.balance ?? 0;
    const yesterdayElectricity = user.yesterdayTotalElectricityCost ?? 0;

    let newType: BalanceModalType = BalanceModalType.NONE;

    if (balance < 0) {
      newType = BalanceModalType.NEGATIVE_BALANCE;
    } else if (balance < yesterdayElectricity * 7) {
      newType = BalanceModalType.LOW_BALANCE;
    }

    if (newType !== modalType) {
      setModalType(newType);
      setIsOpen(newType !== BalanceModalType.NONE);
    }
  }, [user, modalType]);

  const { title, content } = useMemo(() => {
    switch (modalType) {
      case BalanceModalType.NEGATIVE_BALANCE:
        return {
          title: 'Your Balance is negative!',
          content: (
            <Typography variant='body1' gutterBottom>
              Your balance is negative. Please top up your Balance to keep your Miners online!
            </Typography>
          ),
        };
      case BalanceModalType.LOW_BALANCE:
        return {
          title: 'Your Balance is low!',
          content: (
            <Typography variant='body1' gutterBottom>
              Your balance is low and your miners may be turned off soon. Top up your Balance to keep your Miners
              online!
            </Typography>
          ),
        };
      default:
        return { title: '', content: null };
    }
  }, [modalType]);

  return (
    <>
      {isOpen && (
        <AlertModal
          title={title}
          content={content}
          primaryButtonText='Top up'
          primaryButtonHandler={() => setIsTopupOpened(true)}
          onClose={() => setIsOpen(false)}
        />
      )}
      {isTopupOpened && <ModalTopUp isOpen={isTopupOpened} onClose={() => setIsTopupOpened(false)} />}
    </>
  );
};
